module.exports = __webpack_public_path__ + "img/Income.c5a39b50.svg";